import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type ArchiveGroupFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function ArchiveGroupFailureModal({ isOpen, handleClose }: ArchiveGroupFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="archive-group-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.somethingWentWrong')}
        description={t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
